import { getUserRoles } from "../../api/auth";

/**
 * Гүйлгээний Баримт permission levels, mapped onto the existing SFG roles.
 *
 * MANAGE (ADMIN, MODERATOR)  - view, import, create, upload/replace/remove the PDF receipt,
 *                              edit and delete.
 * VIEW   (AUTHOR, CUSTOMER)  - read only: list, search, filter and view or download the
 *                              attached PDF. No add, edit, upload, replace or delete control is
 *                              rendered for them.
 *
 * This is deliberately stricter than the Гүйлгээний төлөвлөгөө module, where AUTHOR may also
 * add rows. The backend enforces the same mapping on every write endpoint; this module only
 * decides what to render.
 */
export const TRANSACTION_RECEIPT_VIEW_ROLES = ["ADMIN", "MODERATOR", "AUTHOR", "CUSTOMER"];

/** Roles allowed to change anything at all. Mirrored and enforced on the backend. */
export const TRANSACTION_RECEIPT_MANAGE_ROLES = ["ADMIN", "MODERATOR"];

export const TRANSACTION_RECEIPT_LEVEL_VIEW = "VIEW";
export const TRANSACTION_RECEIPT_LEVEL_MANAGE = "MANAGE";

export function getTransactionReceiptAccess(token = localStorage.getItem("access_token")) {
    const roles = getUserRoles(token);

    const canView = roles.some((role) => TRANSACTION_RECEIPT_VIEW_ROLES.includes(role));
    const canManage = roles.some((role) => TRANSACTION_RECEIPT_MANAGE_ROLES.includes(role));

    return {
        role: roles[0] || null,
        canView,
        canAdd: canManage,
        canUploadReceipt: canManage,
        canEdit: canManage,
        canDelete: canManage,
        permissionLevel: canManage
            ? TRANSACTION_RECEIPT_LEVEL_MANAGE
            : TRANSACTION_RECEIPT_LEVEL_VIEW,
    };
}
